import React from 'react';

export const CardSkeleton = () => (
  <div className="animate-pulse bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg">
    <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-4"></div>
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-2"></div>
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3"></div>
  </div>
);

export const TableSkeleton = () => (
  <div className="animate-pulse space-y-3">
    {[1, 2, 3, 4, 5].map(i => (
      <div key={i} className="flex gap-4">
        <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded flex-1"></div>
        <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
        <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
      </div>
    ))}
  </div>
);